import { logEvent } from 'commons/utils/tracking';
import {
  CORE_APP_STORE_DROPSHIPPING_APP_CLICK,
  CORE_APP_STORE_DROPSHIPPING_LIST_CLICK,
  CORE_PRODUCT_ADD_ONBOARDING_CLICK,
  CORE_PRODUCT_IMPORT_ONBOARDING_CLICK,
  PRODUCT_LIST_ADD_PRODUCT_CLICK,
  PRODUCT_LIST_EXPORT_IMPORT_CLICK,
  PRODUCT_LIST_FILTERS_FILTER_CLICK,
  SHIPPING_DELETE_DISTRIBUTION_CENTER,
  SHIPPING_DELETE_DISTRIBUTION_CENTER_SUBMIT,
  PRODUCT_MENU_CLICK,
  PRODUCT_MENU_LIST_CLICK,
  PRODUCT_SAVE_CLICK,
  PRODUCT_SAVE_RESULT,
  PRODUCT_LIST_ORGANIZE_CLICK,
  PRODUCT_LIST_PAGE_VIEW,
} from 'config/trackingEvents';
import { ProductsFiltersType } from './productsServices';

// CATALOG EVENTS

type ModeType = 'create' | 'edit';
type ResultType = 'success' | 'error';

export const trackingProductsMenuClick = (): void => {
  logEvent(PRODUCT_MENU_CLICK, {});
};

export const trackingProductsMenuListClick = (): void => {
  logEvent(PRODUCT_MENU_LIST_CLICK, {});
};

export const trackingProductSaveClick = (params: { mode: ModeType }): void => {
  logEvent(PRODUCT_SAVE_CLICK, params);
};

export const trackingProductSaveResult = (params: {
  mode: ModeType;
  result: ResultType;
}): void => {
  logEvent(PRODUCT_SAVE_RESULT, params);
};

export const trackingProductListOrganizeClick = (): void => {
  logEvent(PRODUCT_LIST_ORGANIZE_CLICK, {});
};

export const trackingProductListAddProductClick = (): void => {
  logEvent(PRODUCT_LIST_ADD_PRODUCT_CLICK, {});
};

export const trackingProductListExportImportClick = (): void => {
  logEvent(PRODUCT_LIST_EXPORT_IMPORT_CLICK, {});
};

export const trackingProductListPageView = (): void => {
  logEvent(PRODUCT_LIST_PAGE_VIEW, {});
};

// CORE EVENTS

export const trackingCoreProductAddOnboardingClick = (): void => {
  logEvent(CORE_PRODUCT_ADD_ONBOARDING_CLICK, {});
};

export const trackingCoreProductImportOnboardingClick = (): void => {
  logEvent(CORE_PRODUCT_IMPORT_ONBOARDING_CLICK, {});
};

export const trackingCoreAppStoreDropshippingAppClick = (): void => {
  logEvent(CORE_APP_STORE_DROPSHIPPING_APP_CLICK, {});
};

export const trackingCoreAppStoreDropshippingListClick = (): void => {
  logEvent(CORE_APP_STORE_DROPSHIPPING_LIST_CLICK, {});
};

export const trackingProductListFiltersFilterClick = (
  query: ProductsFiltersType,
): void => {
  logEvent(PRODUCT_LIST_FILTERS_FILTER_CLICK, {
    query: JSON.stringify(query),
  });
};

export const trackingShippingDeleteDistributionCenter = (
  locationId: string,
) => {
  logEvent(SHIPPING_DELETE_DISTRIBUTION_CENTER, {
    locationId: locationId,
  });
};

export const trackingShippingDeleteDistributionCenterSubmit = (params) => {
  logEvent(SHIPPING_DELETE_DISTRIBUTION_CENTER_SUBMIT, params);
};
